import React, { useEffect } from "react";
import News from "../components/News";

const NewsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <News />
    </>
  );
};

export default NewsPage;
